module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-2-Article-w540.b65c7796.jpg";